// @flow

import { withProps } from 'rgs-nfd-ui-kit/ko-components/helpers';
import type { Observable, ObservableArray } from 'rgs-knockout';
import { Tree } from 'rgs-nfd-ui-kit/ko-components/tree/tree';

export type TTreeListProps = {
	isEmpty: Observable<boolean>,
	isRoot: boolean,
	treeData: ObservableArray<*>,
	rowTemplate: NodeList[],
	$tree: Tree,
};

export type TTreeListOptions = {
	props: TTreeListProps,
};

export class TreeList {
	props: TTreeListProps;

	constructor (options: TTreeListOptions) {
		if (!options) {
			this.props = {};
		} else {
			const {
				// isEmpty,
				isRoot,
				$tree,
				treeData,
				rowTemplate,
				...rest
			} = withProps(options);

			this.props = {
				// isEmpty,
				isRoot,
				$tree,
				treeData,
				rowTemplate: rowTemplate,
				rest,
			};
		}
	}
}
